import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { BaseIcon } from "../base-icon";
export var CinchCareBreakdownIcon = function(_param) /*#__PURE__*/ {
    var color = _param.color, _size = _param.size, size = _size === void 0 ? 24 : _size, props = _object_without_properties(_param, [
        "color",
        "size"
    ]);
    return _jsxs(BaseIcon, _object_spread_props(_object_spread({}, props), {
        color: color,
        height: size,
        width: size,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "currentColor",
                fillRule: "evenodd",
                d: "M16.821 19.25a1 1 0 0 0 .88-1.476l-4.822-8.9a1 1 0 0 0-1.758 0l-4.821 8.9a1 1 0 0 0 .879 1.476h9.642Zm-8.803-1.5L12 10.4l3.982 7.35H8.018Z",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ _jsx("path", {
                fill: "currentColor",
                fillRule: "evenodd",
                d: "M22.818 23a1 1 0 0 0 .879-1.477L12.879 1.617a1 1 0 0 0-1.758 0L.303 21.522A1 1 0 0 0 1.182 23h21.636ZM2.022 21.5 12 3.141l9.977 18.36H2.023Z",
                clipRule: "evenodd"
            })
        ]
    }));
};
